/** @format */

import request from 'src/utils/request'

// 获取脚本
export const getScript = async (ID: number) => {
  const result = await request('/oos/?Action=GetScript&Version=2025-01-01', {
    data: { ID },
    method: 'GET'
  })
  return result?.data?.Code === 'success' ? result?.data?.Data : false
}

// 保存脚本
export const saveScript = async (data: any) => {
  const result = await request('/oos/?Action=SaveScript&Version=2025-01-01', {
    data,
    method: 'POST'
  })
  return result?.data?.Code === 'success' ? result?.data?.Data : false
}
